import * as React from "react";
type Props = {
  className?: string,
};
function SvgQuestion({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-question"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM12.758 13.588V13.133C12.758 12.678 12.953 12.457 13.798 11.924C14.838 11.287 15.28 10.65 15.28 9.753C15.28 8.284 13.98 7.205 12.199 7.205C10.197 7.205 8.832 8.466 8.767 10.403L10.691 10.546C10.756 9.532 11.302 8.96 12.186 8.96C12.901 8.96 13.356 9.285 13.356 9.818C13.356 10.26 13.109 10.533 12.277 11.027C11.354 11.586 11.003 12.08 11.003 12.873V13.588H12.758ZM12.953 16.5V14.485H10.873V16.5H12.953Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgQuestion;
